export default "__VITE_ASSET__417110d8__"